import { canRegisterBuyingStation } from "@/utils";

export default [
  {
    path: "/",
    component: () => import("../views/dashboard/Index.vue"),
    children: [
      {
        path: "enterprises",
        name: "Enterprises",
        component: () => import("../views/user/enterprises/Index.vue"),
      },
      {
        path: "enterprises/:id",
        name: "view-enterprises",
        component: () => import("../views/user/enterprises/view/Index.vue"),
      },

      {
        path: "create-enterprises",
        name: "create-enterprises",
        component: () => import("../views/user/enterprises/create/Index.vue"),
      },
      {
        path: "blends-history",
        name: "BlendsHistory",
        component: () =>
          import(
            "../views/deforestation/dds/blends/create-blend-dds/components/BlendsImportHistory.vue"
          ),
      },
      {
        path: "create-blends",
        name: "CreateBlends",
        component: () =>
          import(
            "../views/deforestation/dds/blends/create-blend-dds/create-blends.vue"
          ),
      },
      {
        path: "",
        name: "AdminDashboard",
        redirect: { name: "Dashboard" },
        // component: () => import("../views/dashboard/NoPermission.vue"),
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: () => import("../views/dashboard/Dashboard.vue"),
        meta: { module: "dashboard" },
      },
      {
        path: "dashboard/available-modules",
        name: "AvailableModules",
        component: () => import("../views/dashboard/AvailableModules.vue"),
        meta: { module: "user_listing" },
      },
      {
        path: "home",
        name: "Home",
        component: () => import("../views/dashboard-reports/Dashboard.vue"),
      },
      {
        path: "users/:type?",
        name: "Users",
        component: () => import("../views/user/UserList.vue"),
        meta: { module: "user_listing" },
      },
      {
        path: "upload/bulk-upload",
        name: "UserUpload",
        component: () => import("../views/user/UserBulkUpload.vue"),
        props: true,
      },
      // {
      //     path: 'departments',
      //     name: 'Departments',
      //     component: () => import("../views/roles/DepartmentList.vue")
      // },
      {
        path: "profile",
        name: "profile",
        component: () => import("../views/user/Profile.vue"),
      },
      {
        path: "profile-auth-settings",
        name: "ProfileAuthSet",
        component: () => import("../views/profile-auth/Settings.vue"),
        meta: { module: "profile_authentication" },
      },
      {
        path: "logs",
        name: "ActivityLogs",
        component: () => import("../views/log/LogList.vue"),
        meta: { module: "activity_log" },
      },
      // {
      //     path: 'permissions/:role_number?',
      //     name: 'Permissions',
      //     component: () => import("../views/roles/Permissions.vue")
      // },
      {
        path: "admin-permissions",
        name: "AdminPermissions",
        component: () => import("../views/admin-permissions/Permissions.vue"),
        meta: { module: "permissions" },
      },
      {
        path: "admin-roles",
        name: "AdminRoles",
        component: () => import("../views/roles/RoleList.vue"),
        meta: { module: "admin_roles" },
      },
      {
        path: "memberships",
        name: "MembershipTypes",
        component: () => import("../views/memberships/MembershipList.vue"),
        meta: { module: "membership" },
      },
      {
        path: "faq/:section?",
        name: "Faq",
        component: () => import("../views/faq/FaqTopics.vue"),
        meta: { module: "faq" },
      },
      {
        path: "tutorials",
        name: "TutorialManagement",
        component: () => import("../views/faq/TutorialManagement.vue"),
      },
      {
        path: "activation-key",
        name: "ActivationKey",
        component: () => import("../views/activation-key/Details.vue"),
        meta: { module: "activation" },
      },
      {
        path: "activation-key/list",
        name: "ActivationKeyList",
        component: () => import("../views/activation-key/KeyList.vue"),
        meta: { module: "activation" },
      },
      {
        path: "activation-key/uploadedfiles",
        name: "ActivationKeyFiles",
        component: () => import("../views/activation-key/UploadedFiles.vue"),
        meta: { module: "activation" },
      },
      {
        path: "activation-key/group/:groupId",
        name: "ActivationKeyGroupList",
        component: () => import("../views/activation-key/KeyGroupList.vue"),
        meta: { module: "activation" },
      },
      {
        path: "coming-soon",
        name: "ComingSoon",
        component: () => import("../views/ComingSoon.vue"),
      },
      {
        path: "notifications/list",
        name: "NotificationList",
        component: () => import("../views/notifications/NotificationList.vue"),
        meta: { module: "permissions", requiresAuth: false },
      },
      {
        path: "notifications/sent",
        name: "NotificationSent",
        component: () =>
          import("../views/notifications/NotificationListSent.vue"),
        meta: { module: "permissions" },
      },
        {
        path: "tickets",
        name: "Tickets",
        component: () => import("../views/tickets/ViewTickets.vue"),
      },
      {
        path: "coffee-data/specie",
        name: "CoffeeSpecie",
        component: () => import("../views/coffee/CoffeeSpecie.vue"),
  
      },
      {
        path: "coffee-data/variety",
        name: "CoffeeVariety",
        component: () => import("../views/coffee/CoffeeVariety.vue"),
  
      },
      {
        path: "coffee-data/tree/:tree?",
        name: "CoffeeData",
        component: () => import("../views/coffee/CoffeeList.vue"),
  
      },
      {
        path: "coffee-settings",
        name: "CoffeeSettings",
        component: () => import("../views/coffee/CoffeeSettings.vue"),
        meta: { module: "coffee_data", requiresAuth: true },
      },
      {
        path: "coffee/factory-dashboard/:id",
        name: "FactoryDashboard",
        component: () => import("../views/coffee/FactoryDashboard.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "farm-management",
        name: "FarmManagement",
        component: () => import("../views/farm-management/Index.vue"),
        meta: { module: "member_data" },
        children: [
          {
            path: "farmers",
            component: () => import("../views/farm-management/Farmers.vue"),
            name: "Farmers",
          },
          {
            path: "farmers/:id",
            component: () =>
              import("../views/farm-management/FarmerDetail.vue"),
            name: "farmers_view",
          },
          {
            path: "farmers/view-all-farms/:id",
            component: () => import("../views/farm-management/ViewAllFarm.vue"),
            name: "view_all_farms",
          },
          {
            path: "farmers/farm-activity/:userId",
            component: () =>
              import("../views/farm-management/FarmActivity.vue"),
            name: "farm_activity",
          },
          {
            path: "farmers/show-on-maps/:farmId/:farmerId",
            component: () => import("../views/farm-management/MapView.vue"),
            name: "farmers_show_on_maps",
          },
          {
            path: "farms",
            component: () => import("../views/farm-management/Farms.vue"),
            name: "Farms",
          },
          {
            path: "farms/upload-validations",
            component: () =>
              import("../views/farm-management/FarmUploadValidations.vue"),
            name: "FarmUploadValidations",
          },
          {
            path: "farm/register",
            name: "FarmRegistartion",
            component: () =>
              import("../views/farm-management/FarmRegistration.vue"),
          },
          // {
          //   path: "farm/register",
          //   name: "FarmRegistartion",
          //   component: () =>
          //     import("../views/farm-management/FarmRegistration.vue"),
          // },

          {
            path: "edit-farm/:farmId",
            name: "EditFarms",
            component: () =>
              import("../views/farm-management/EditPrimaryFarm.vue"),
          },
          {
            path: "farm-info/:farmId/:tabId",
            name: "FarmInfo",
            component: () => import("../views/farm-management/FarmInfo.vue"),
          },

          {
            path: "zones/:id",
            name: "ZonesList",
            component: () =>
              import("../views/farm-management/zone/FarmZoneList.vue"),
          },
          {
            path: "add-zone",
            name: "FarmZones",
            component: () =>
              import("../views/farm-management/zone/FarmGeofenceZone.vue"),
          },
          {
            path: "edit-zone/:id",
            name: "FarmEditZone",
            component: () =>
              import("../views/farm-management/zone/FarmGeofenceZoneEdit.vue"),
          },
          {
            path: "zone-details/:id",
            name: "ZoneDetails",
            component: () =>
              import("../views/farm-management/zone/ZoneDetails.vue"),
          },
          {
            path: "farm_activities_calendar",
            name: "FarmCalenderActivities",
            component: () =>
              import("../views/farm-management/FarmCalenderActivities.vue"),
          },
          {
            path: "farm-activities",
            component: () =>
              import("../views/farm-management/FarmActivitiesCalendarView.vue"),
            name: "farm_activities",
          },
          {
            path: "farm-access-control",
            name: "FarmAccessControl",
            component: () =>
              import("../views/farm-management/AccessControl.vue"),
          },
        ],
      },
      {
        path: "member-data",
        name: "MemberData",
        component: () => import("../views/member-data/Index.vue"),
        meta: { module: "member_data" },
        children: [
          {
            path: "buying-station",
            name: "BuyingStation",
            component: () =>
              import("../views/member-data/buying-station/BuyingStation.vue"),
          },
          {
            path: "buying-station/purchase-order/:id",
            name: "PurchaseOrderList",
            component: () =>
              import(
                "../views/member-data/buying-station/PurchaseOrderList.vue"
              ),
          },
          {
            path: "buying-station/processing-batch/:id",
            name: "ProcessingBatchList",
            component: () =>
              import(
                "../views/member-data/buying-station/ProcessingBatchList.vue"
              ),
          },
          {
            path: "manage-offline-farmers",
            name: "ManageOfflineFarmers",
            component: () =>
              import("../views/member-data/ManageOfflineFarmers.vue"),
          },
        ],
      },
      {
        path: "crops-overview",
        name: "CropsTraceOverview",
        component: () => import("../views/crops-overview/Index.vue"),
        meta: { module: "crops_overview" },
        children: [
          {
            path: "traceability",
            name: "CropsTraceOverviewTraceability",
            component: () =>
              import("../views/crops-overview/traceability/Index.vue"),
          },
        ],
      },
      {
        path: "coffee/buying-station",
        name: "CoffeeBuyingStation",
        component: () => import("../views/coffee/buying-station/BuyingStationList.vue"),
      },
      {
        path: "coffee/society-listing",
        name: "CoffeeSocietyListing",
        component: () => import("../views/coffee/buyingStation/SocietyListing/index.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "coffee/buying-station/register",
        name: "CoffeeRegisterBuyingStation",
        component: () => import("../views/coffee/buying-station/RegisterBuyingStation.vue"),
        // NACCU/Kenya-only feature; redirect other clients to the buying-station list.
        beforeEnter: (to, from, next) => {
          if (canRegisterBuyingStation()) next();
          else next("/coffee/buying-station");
        },
      },
      {
        path: "coffee/buying-station/roles",
        name: "CoffeeBuyingStationRoles",
        component: () => import("../views/coffee/buying-station/BuyingStationRoles.vue"),
        // NACCU/Kenya-only feature; redirect other clients to the buying-station list.
        beforeEnter: (to, from, next) => {
          if (canRegisterBuyingStation()) next();
          else next("/coffee/buying-station");
        },
      },
      {
        path: "coffee/buying-station/roles/:roleId/permissions",
        name: "CoffeeBuyingStationRolePermissions",
        component: () => import("../views/coffee/buying-station/BuyingStationRolePermissions.vue"),
        beforeEnter: (to, from, next) => {
          if (canRegisterBuyingStation()) next();
          else next("/coffee/buying-station");
        },
      },
      {
        path: "coffee/buying-station/:id",
        name: "CoffeeBuyingStation",
        component: () => import("../views/coffee/buying-station/BuyingStationDetails.vue"),
      },
      {
        path: "coffee/buying-station/:id/associated-farms",
        name: "CoffeeBuyingStation",
        component: () => import("../views/coffee/buying-station/AssociatedFarms.vue"),
      },
      {
        path: "coffee/buying-station/parchment-deliveries",
        name: "CoffeeBuyingStationParchmentDeliveries",
        component: () =>
          import(
            "../views/coffee/buying-station/parchment-deliveries/ParchmentDeliveryList.vue"
          ),
      },
      {
        path: "coffee/buying-station/parchment-deliveries/bulk-import",
        name: "CoffeeBuyingStationParchmentDeliveriesBulkImport",
        component: () =>
          import(
            "../views/coffee/buying-station/parchment-deliveries/BulkImport.vue"
          ),
      },
      {
        path: "coffee/buying-station/parchment-deliveries/bulk-import/success",
        name: "CoffeeBuyingStationParchmentDeliveriesBulkImportSuccess",
        component: () =>
          import(
            "../views/coffee/buying-station/parchment-deliveries/components/bulk-import/BulkImportResult.vue"
          ),
        props: { mode: "success" },
      },
      {
        path: "coffee/buying-station/parchment-deliveries/bulk-import/error",
        name: "CoffeeBuyingStationParchmentDeliveriesBulkImportError",
        component: () =>
          import(
            "../views/coffee/buying-station/parchment-deliveries/components/bulk-import/BulkImportResult.vue"
          ),
        props: { mode: "error" },
      },
      {
        path: "coffee/buying-station/:buyingStationId/create-farm",
        name: "createFarm",
        component: () => import("../views/farm-management/FarmRegistration.vue"),
      },
      {
        path: "coffee/buying-station/purchase-order/:id",
        name: "CoffeeBuyingStationPurchaseOrderList",
        component: () =>
          import("../views/coffee/buying-station/purchase-order/PurchaseOrderList.vue"),
      },
      {
        path: "coffee/buying-station/processing-batch/:id",
        name: "CoffeeBuyingStationProcessingBatchList",
        component: () =>
          import("../views/coffee/buying-station/processing-batch/ProcessingBatchList.vue"),
      },
      {
        path: "/survey-builder",
        component: () => import("../views/survey-builder/Index.vue"),
        meta: { module: "survey_builder" },
        children: [
          {
            path: "",
            name: "SurveyBuilder",
            component: () => import("../views/survey-builder/SurveyList.vue"),
          },
          {
            path: "Standard-Survey",
            name: "SurveyList",
            component: () =>
              import("../views/esg-platform/survey-builder/SurveyList.vue"),
          },
          {
            // Must precede the optional-param SurveyDetails route below,
            // otherwise "responses" is captured as :goalTitle.
            path: "Standard-Survey/:id/responses",
            name: "SurveyResponses",
            component: () =>
              import("../views/esg-platform/survey-builder/SurveyResponses.vue"),
          },
          {
            path: "Standard-Survey/:id/:goalTitle?/:targetYear?",
            name: "SurveyDetails",
            component: () =>
              import("../views/esg-platform/survey-builder/SurveyDetails.vue"),
          },
          {
            path: "download-survey-history/:id",
            name: "DownloadSurveyHistory",
            component: () =>
              import("../views/survey-builder/DownloadSurveyList.vue"),
          },
          {
            path: ":id/submitted",
            name: "SurveySubmitted",
            component: () =>
              import("../views/survey-builder/SurveySubmitted.vue"),
          },
          {
            path: ":id",
            name: "SingleSurveyList",
            component: () =>
              import("../views/survey-builder/SingleSurveyList.vue"),
          },
        ],
      },
      {
        path: "plantation",
        name: "Plantation",
        component: () => import("../views/plantation/Index.vue"),
        meta: { module: "plantations" },
      },
      {
        path: "payments",
        name: "Payments",
        // component: () => import("../views/role-request/Index.vue"),
        meta: { module: "payments" },
      },
      {
        path: "role-request",
        name: "RoleRequest",
        component: () => import("../views/role-request/Index.vue"),
        meta: { module: "role_requests" },
      },
      {
        path: "reports",
        name: "Reports",
        component: () => import("../views/reports/Index.vue"),
        meta: { module: "reports" },
      },
      {
        path: "avocado",
        name: "Reports1",
        component: () => import("../views/oma/Index.vue"),
        meta: { module: "reports" },
        children: [
          {
            path: "land-suitability",
            name: "LandSuitibilityList",
            component: () =>
              import("../views/oma/land-suitability/LandSuitabilityList.vue"),
          },
          {
            path: "land-suitability/generate-and-view-report/:id?",
            name: "LandSuitibilityGenerateAndViewReport",
            component: () =>
              import(
                "../views/oma/land-suitability/GenerateReportAndViewReport.vue"
              ),
          },
          {
            path: "weather-analysis",
            name: "WeatherAnalysisList",
            component: () =>
              import("../views/oma/weather-analysis/WeatherAnalysisList.vue"),
          },
          {
            path: "weather-analysis/generate-report/:id?",
            name: "WeatherAnalysisGenerateReport",
            component: () =>
              import("../views/oma/weather-analysis/GenerateReport.vue"),
          },
          {
            path: "land-suitability-view",
            name: "LandSuitabilityView",
            component: () =>
              import("../views/oma/land-suitability/LandSuitabilityView.vue"),
          },
          {
            path: "satellite",
            name: "SatelliteReports",
            component: () => import("../views/reports/SatelliteReports.vue"),
          },
        ],
      },
      {
        path: "avocado-trees",
        component: () => import("../views/oma/Index.vue"),
        meta: { module: "avocado-trees" },
        children: [
          {
            path: "",
            name: "AvocadoTrees",
            component: () =>
              import("../views/avocado-trees/AvocadoTreeList.vue"),
          },
          {
            path: ":id",
            name: "SingleAvocadoTreeList",
            component: () =>
              import("../views/avocado-trees/SingleAvocadoTreeList.vue"),
          },
          {
            path: ":id/details",
            name: "AvocadoTreeDetail",
            component: () =>
              import("../views/avocado-trees/AvacadoTreeDetail.vue"),
          },
        ],
      },
      {
        path: "deforestation",
        component: () => import("../views/deforestation/Index.vue"),
        meta: { module: "deforestation" },
        children: [
          {
            path: "dds-profile",
            name: "DDSProfile",
            component: () => import("../views/deforestation/dds/Profile.vue"),
          },
          {
            path: "compliance-reports",
            name: "DeforestationComplianceReports",
            component: () =>
              import(
                "../views/deforestation/DeforestationComplianceReports.vue"
              ),
          },
          {
            path: "dispute-resolution",
            name: "DisputeResolution",
            component: () =>
              import(
                "../views/deforestation/dds/dispute-resolution/DisputeResolution.vue"
              ),
          },
          {
            path: "eudr-report/:id/:type",
            name: "EudrAssessmentReport",
            component: () =>
              import("../views/deforestation/components/AssessmentReport.vue"),
          },
          {
            path: "eudr-report-dds/:reportRequestId/:type",
            name: "EudrAssessmentReportDDS",
            component: () =>
              import(
                "../views/deforestation/components/AssessmentReportDDS.vue"
              ),
          },
          //Eudr certification
          {
            path: "certification",
            name: "ComplianceCertification",
            component: () =>
              import("../views/deforestation/ComplianceCertification.vue"),
          },
          {
            path: "certification-eudr-assement/:id",
            name: "ComplianceCertificationEudrAssessment",
            component: () =>
              import(
                "../views/deforestation/components/ComplainceAssessmentReport.vue"
              ),
          },
          {
            path: "shipment",
            name: "Shipment",
            component: () =>
              import("../views/deforestation/dds/shipping/ShippingList.vue"),
          },
          {
            path: "manage-farms",
            name: "ManageFarms",
            component: () =>
              import("../views/deforestation/dds/manage-farms/FarmList.vue"),
          },
          {
            path: "manage-products",
            name: "ManageProducts",
            component: () =>
              import(
                "../views/deforestation/dds/blends/manage-products/Products.vue"
              ),
          },
          {
            path: "manage-products/:productId?/sub-products",
            name: "ManageSubProducts",
            component: () =>
              import(
                "../views/deforestation/dds/blends/manage-products/SubProducts.vue"
              ),
            // props: true,
          },
          {
            path: "create-shipment",
            name: "shipmentCreate",
            component: () =>
              import("../views/deforestation/dds/shipping/CreateShipment.vue"),
          },
          {
            path: "shipment-detail/:id?",
            name: "shipmentDetail",
            component: () =>
              import("../views/deforestation/dds/shipping/ShipmentDetails.vue"),
          },
          {
            path: "due-diligence-dashboard",
            name: "dueDiligenceDashboard",
            component: () =>
              import("../views/deforestation/dds/dashboard/Index.vue"),
          },
          {
            // Union / National level Coffee root dashboard
            path: "coffee-root-dashboard",
            name: "coffee_root_dashboard",
            component: () =>
              import("../views/deforestation/coffee/root-dashboard/Index.vue"),
          },
          {
            path: "due-diligence-reports",
            name: "dueDiligenceReports",
            component: () =>
              import(
                "../views/deforestation/dds/reports/DueDeligenceReports.vue"
              ),
          },
          {
            path: "create-due-diligence-reports/:id?/:show?",
            name: "createDueDiligenceReports",
            component: () =>
              import(
                "../views/deforestation/dds/reports/CreateDueDiligenceReport.vue"
              ),
          },
          {
            path: "compliance-assessment/:id/mitigation",
            name: "complianceRiskMitigation",
            component: () =>
              import(
                "../views/deforestation/components/AssessmentRiskMitigation.vue"
              ),
          },
          {
            path: "risk-assessment-create",
            name: "rsk-create",
            component: () =>
              import("../views/deforestation/dds/RiskAssessment.vue"),
          },
          {
            path: "assessment-list",
            name: "AssessmentList",
            component: () =>
              import(
                "../views/deforestation/dds/assessment/AssessmentList.vue"
              ),
          },
          {
            path: "assessment-details/:id",
            name: "AssessmentDetails",
            component: () =>
              import(
                "../views/deforestation/dds/assessment/AssessmentDetails.vue"
              ),
          },
          {
            path: "producers",
            name: "Producers",
            component: () =>
              import("../views/deforestation/dds/producers/Index.vue"),
          },
          {
            path: "suppliers",
            name: "Suppliers",
            component: () =>
              import("../views/deforestation/dds/suppliers/Index.vue"),
          },
          {
            path: "operators",
            name: "Operators",
            component: () =>
              import("../views/deforestation/dds/operators/Index.vue"),
          },
          {
            path: "settings",
            name: "EUDRSettings",
            component: () =>
              import("../views/deforestation/dds/EUDRSettings.vue"),
          },
          // diligence guide
          {
            path: "due-diligence-guide",
            name: "dueDiligenceGuide",
            component: () =>
              import("../views/deforestation/dds/DiligenceGuide.vue"),
            meta: { requiresAuth: true },
          },
          {
            path: "view-dds-summary/:id",
            name: "ViewDDSSummary",
            component: () =>
              import("../views/deforestation/dds/reports/ViewDDSSummary.vue"),
          },

          {
            path: "exporter-summary-report/:id",
            name: "ExporterSummaryReport",
            component: () =>
              import("../views/deforestation/dds/reports/ExporterSummaryReport.vue"),
          },
          // Supplier module
          {
            path: "supplier-dashboard",
            name: "supplierDashboard",
            component: () =>
              import(
                "../views/deforestation/supplierModule/dashboard/index.vue"
              ),
          },
          {
            path: "supplier-profile",
            name: "supplierProfile",
            component: () =>
              import("../views/deforestation/supplierModule/profile.vue"),
          },
          {
            path: "supplier-due-diligence-reports",
            name: "supplierDueDiligenceReports",
            component: () =>
              import(
                "../views/deforestation/supplierModule/reports/DueDeligenceReports.vue"
              ),
          },
          {
            path: "supplier-farms",
            name: "supplierFarms",
            component: () =>
              import(
                "../views/deforestation/supplierModule/my-farms/Index.vue"
              ),
          },
          {
            path: "producer-list",
            name: "supplierProducers",
            component: () =>
              import(
                "../views/deforestation/supplierModule/producers/Index.vue"
              ),
          },

          // BLENDS ROUTES
          {
            path: "manage-products",
            name: "ManageProducts",
            component: () =>
              import(
                "../views/deforestation/dds/blends/manage-products/Products.vue"
              ),
          },
          {
            path: "manage-products/:productId?/sub-products",
            name: "ManageSubProducts",
            component: () =>
              import(
                "../views/deforestation/dds/blends/manage-products/SubProducts.vue"
              ),
            // props: true,
          },
          {
            path: "eudr-exempt-products",
            name: "EUDRExemptProducts",
            component: () =>
              import(
                "../views/deforestation/dds/blends/EUDR-exempt-products/Index.vue"
              ),
          },
          {
            path: "add-eudr-exempt-product/:id?",
            name: "AddEUDRExemptProduct",
            component: () =>
              import(
                "../views/deforestation/dds/blends/EUDR-exempt-products/Create.vue"
              ),
            props: true,
          },
          {
            path: "eudr-exempt-products/:id?/view",
            name: "ViewEUDRExemptProduct",
            component: () =>
              import(
                "../views/deforestation/dds/blends/EUDR-exempt-products/View.vue"
              ),
          },

          {
            path: "blends-list",
            name: "Blends",
            component: () =>
              import("../views/deforestation/dds/blends/BlendList.vue"),
          },
          {
            path: "blend-settings",
            name: "blendSettings",
            component: () =>
              import(
                "../views/deforestation/dds/blends/blend-settings/Index.vue"
              ),
          },
          {
            path: "create-blend-settings",
            name: "createBlendSettings",
            component: () =>
              import(
                "../views/deforestation/dds/blends/blend-settings/CreateBlendSettings.vue"
              ),
          },
          {
            path: "edit-blend-settings/:id",
            name: "editBlendSettings",
            component: () =>
              import(
                "../views/deforestation/dds/blends/blend-settings/CreateBlendSettings.vue"
              ),
          },
          {
            path: "import-blends",
            name: "importBlends",
            component: () =>
              import(
                "../views/deforestation/dds/blends/create-blend-dds/import-blend.vue"
              ),
          },
          {
            path: "create-blends/:id/final-report",
            name: "finalReport",
            component: () =>
              import(
                "../views/deforestation/dds/blends/create-blend-dds/final-report.vue"
              ),
          },
          {
            path: "create-blends/:id?/:previewMode?",
            name: "createBlend",
            component: () =>
              import(
                "../views/deforestation/dds/blends/create-blend-dds/create-blends.vue"
              ),
          },
          {
            path: "regional-risk-assessment",
            name: "regionalRiskAssessment",
            component: () =>
              import(
                "../views/deforestation/dds/regional-risk-assessment/IndexList.vue"
              ),
          },
          {
            path: "create-regional-risk-assessment",
            name: "createRegionalRiskAssessment",
            component: () =>
              import(
                "../views/deforestation/dds/regional-risk-assessment/CreateRegional.vue"
              ),
          },
          {
            path: "edit-regional-risk-assessment/:id",
            name: "editRegionalRiskAssessment",
            component: () =>
              import(
                "../views/deforestation/dds/regional-risk-assessment/CreateRegional.vue"
              ),
          },
          {
            path: "duplicate-regional-risk-assessment/:id",
            name: "duplicateRegionalRiskAssessment",
            component: () =>
              import(
                "../views/deforestation/dds/regional-risk-assessment/CreateRegional.vue"
              ),
          },
          {
            path: "summary-regional-risk-assessment",
            name: "summaryRegionalRiskAssessment",
            component: () =>
              import(
                "../views/deforestation/dds/reports/tabs/partials/RegionalRiskSummary.vue"
              ),
          },
          {
            path: "iyb-scores",
            name: "iybScoreIndex",
            component: () =>
              import(
                "../views/deforestation/dds/iyb-score/IndexList.vue"
              ),
          },
          {
            path: "iyb-scores/import",
            name: "importIYBSpreadsheet",
            component: () =>
              import(
                "../views/deforestation/dds/iyb-score/ImportSpreadsheet.vue"
              ),
          },
        ],
      },

        {
        path: "dashboard-reports",
        name: "dashboard-reports",
        component: () => import("../views/dashboard-reports/Dashboard.vue"),
        meta: { module: "report_dashboard" },
        children: [
          {
            path: "",
            name: "DashboardReports",
            component: () =>
              import("../views/dashboard-reports/Dashboard.vue"),
          },
          {
            path: "dashboard",
            name: "dashboard",
            component: () => import("../views/dashboard/Dashboard.vue"),
          },
        ],
      },

      // 👇 moved OUT of children
      {
        path: "/dashboard-reports/:type/detail",
        name: "ReportDetail",
        component: () =>
          import("../views/dashboard-reports/ReportDetail.vue")
      },
      {
        path: "traceability",
        name: "Traceability",
        component: () => import("../views/traceability/Index.vue"),
        meta: { module: "traceability" },
      },
      {
        path: "green-beans",
        name: "Green beans",
        component: () => import("../views/green-beans/Index.vue"),
        meta: { module: "green-beans" },
      },
      {
        path: "/green-beans/:greenBeanId",
        name: "Green Bean Lot",
        component: () => import("../views/green-beans/GreenBeanLot.vue"),
        meta: { module: "faq" },
      },

      {
        path: "green-coffee",
        name: "GreenCoffee",
        component: () => import("../views/green-coffee/Index.vue"),
      },

      {
        path: "green-coffee",
        name: "GreenCoffee",
        component: () => import("../views/green-coffee/Index.vue"),
      },
      {
        path: "green-coffee/bulk-import",
        name: "GreenCoffeeBulkImport",
        component: () => import("../views/green-coffee/components/BulkImport/BulkImport.vue"),
      },
      {
        path: "green-coffee/bulk-import/:id",
        name: "GreenCoffeeBulkImportResult",
        component: () => import("../views/green-coffee/components/BulkImport/BulkImportResult.vue"),
        props: true,
      },
      {
        path: "coffee/purchase-orders-bulk-import",
        name: "CoffeePurchaseOrdersBulkImport",
        component: () =>
          import("../views/coffee/buying-station/purchase-orders-bulk-import/BuyingStationOrderBulkImport.vue"),
      },
      {
        path: "coffee/purchase-orders-bulk-import/:id",
        name: "CoffeePurchaseOrdersBulkImportResult",
        component: () =>
          import("../views/coffee/buying-station/purchase-orders-bulk-import/components/BulkImportResult.vue"),
        props: true,
      },
      {
        path: "coffee/processing-batch/bulk-import",
        name: "ProcessingBatchBulkImport",
        component: () =>
          import("../views/coffee/buying-station/processing-batch/components/BulkImport/ProcessingBatchBulkImport.vue"),
      },
      {
        path: "coffee/processing-batch/bulk-import/:id",
        name: "ProcessingBatchBulkImportResult",
        component: () =>
          import("../views/coffee/buying-station/processing-batch/components/BulkImport/ProcessingBatchBulkImportResult.vue"),
        props: true,
      },
      {
        path: "cacao",
        component: () => import("../views/cacao/Index.vue"),
        meta: { module: "cacao" },
        children: [
          {
            path: "plantation",
            name: "CacaoPlantation",
            component: () =>
              import("../views/cacao/plantation/PlantationList.vue"),
          },
          {
            path: "cacao-data",
            name: "cacaoData",
            component: () =>
              import("../views/cacao/cacao-data/CacaoDataList.vue"),
          },
          {
            path: "dry-cacao",
            name: "dryCacao",
            component: () =>
              import("../views/cacao/cacao-data/CacaoDataList.vue"),
          },
          {
            path: "traceability",
            name: "traceability",
            component: () => import("../views/cacao/traceability/Index.vue"),
          },
          // add route for buy sell overview
          {
            path: "buy-sell-overview",
            name: "BuySellOverview",
            component: () =>
              import("../views/cacao/buy-sell/BuySellOverview.vue"),
          },
          {
            path: "buy-sell-overview/:id",
            name: "BuySellOverviewDetail",
            component: () =>
              import("../views/cacao/buy-sell/BuySellFarmDetail.vue"),
            props: true,
          },
        ],
      },
      {
        path: "oma-reports",
        component: () => import("../views/cacao/Index.vue"),
        meta: { module: "oma-reports" },
        children: [
          {
            path: "weather-analysis",
            name: "WeatherAnalysis",
            component: () =>
              import("../views/cacao/plantation/PlantationList.vue"),
          },
          {
            path: "satellite",
            name: "SatelliteReports",
            component: () => import("../views/reports/SatelliteReports.vue"),
          },
          {
            path: "satellite/:id",
            name: "SatelliteDetailReports",
            component: () =>
              import("../views/reports/SatelliteDetailReport.vue"),
          },
        ],
      },
      {
        path: "download-history",
        name: "DownloadHistory",
        component: () => import("../views/notifications/DownloadHistory.vue"),
      },

      // ========= MARKETPLACE ROUTES ===========
      {
        path: "/marketplace",
        component: () => import("../views/marketplace/index.vue"),
        meta: { module: "marketplace", requiresAuth: false },
        children: [
          {
            path: "dashboard",
            name: "marketplaceDashboard",
            component: () => import("../views/marketplace/dashboard.vue"),
          },
          {
            path: "sellers",
            name: "marketplaceSellers",
            component: () => import("../views/marketplace/sellers.vue"),
          },
          {
            path: "categories",
            name: "marketplaceCategory",
            component: () => import("../views/marketplace/category.vue"),
          },
          {
            path: "/category/:id",
            component: () => import("../views/marketplace/sub-category.vue"),
            name: "sub-category",
          },
          {
            path: "products",
            name: "marketplaceProducts",
            component: () => import("../views/marketplace/products/index.vue"),
          },
          {
            path: "products/add/:id?/:step?",
            name: "marketplaceProductsAdd",
            component: () =>
              import("../views/marketplace/products/add-product.vue"),
          },
          {
            path: "orders",
            name: "marketplaceOrders",
            component: () => import("../views/marketplace/orders.vue"),
          },
          {
            path: "orders/:id",
            name: "marketplaceOrderDetails",
            component: () =>
              import("../views/marketplace/components/orders/orderDetails.vue"),
          },
          {
            path: "settings",
            name: "marketplaceSettings",
            component: () => import("../views/marketplace/settings.vue"),
          },
        ],
      },

      // ========= SUPER ADMIN AI REPORTS MANAGEMENT ===========
      {
        path: "/ai-reports-management",
        name: "superAdminAiReportsManagement",
        component: () => import("../views/super-admin/ai-reports-management/Index.vue"),
        meta: { requiresAuth: true, superAdminOnly: true },
      },

      // ========= ESG-PLATFORM ROUTES ===========
      {
        path: "/esg-platform",
        name: "esgPlatform",
        component: () => import("../views/esg-platform/index.vue"),
        meta: { module: "esg-platform", requiresAuth: false },
        children: [
          {
            path: "standards",
            name: "esgPlatformStandards",
            component: () =>
              import("../views/esg-platform/standards/standardList.vue"),
          },
          {
            path: "create-esg-standard",
            name: "createEsgStandard",
            component: () =>
              import("../views/esg-platform/standards/createEsgStandard.vue"),
          },
          {
            path: "esg-my-products",
            name: "esgMyProducts",
            component: () =>
              import("../views/esg-platform/my-products/Products.vue"),
          },
          {
            path: "esg-dashboard/:type?",
            name: "esgAccountDashboard",
            component: () =>
              import("../views/esg-platform/dashboard/AccountDashboard.vue"),
          },
          {
            path: "esg-reports-builder",
            name: "esgReportsBuilder",
            component: () =>
              import("../views/esg-platform/report-builder/index.vue"),
          },
          {
            path: "manage-template",
            name: "manageTemplate",
            component: () =>
              import(
                "../views/esg-platform/report-builder/manage-template/index.vue"
              ),
          },
          {
            path: "create-new-esg-template",
            name: "createNewEsgTemplate",
            component: () =>
              import(
                "../views/esg-platform/report-builder/create-template/index.vue"
              ),
          },
          {
            path: "create-new-esg-report",
            name: "createNewEsgReport",
            component: () =>
              import(
                "../views/esg-platform/report-builder/create-report/index.vue"
              ),
          },
          {
            path: "preview-esg-standard/:id",
            name: "previewEsgStandard",
            component: () =>
              import("../views/esg-platform/standards/createEsgStandard.vue"),
          },
          {
            path: "edit-esg-standard/:id",
            name: "editEsgStandard",
            component: () =>
              import("../views/esg-platform/standards/createEsgStandard.vue"),
          },
          {
            path: "progress",
            name: "esgPlatformProgress",
            component: () =>
              import("../views/esg-platform/progress/progressList.vue"),
          },
          {
            path: "survey-list",
            name: "ESGSurveyList",
            component: () =>
              import("../views/esg-platform/survey-builder/SurveyList.vue"),
          },
          {
            path: "survey-details/:id/:goalTitle?/:targetYear?",
            name: "ESGSurveyDetails",
            component: () =>
              import("../views/esg-platform/survey-builder/SurveyDetails.vue"),
          },
          {
            path: "esg-standard-protocol/:id?",
            name: "esgStandardProtocol",
            component: () =>
              import("../views/esg-platform/dashboard/StandardProtocol.vue"),
          },
          {
            path: "start-esg-protocol/:id",
            name: "startEsgProtocol",
            component: () =>
              import(
                "../views/esg-platform/esg-protocol/EsgProtocolDetail.vue"
              ),
            props: true,
          },
          {
            path: "protocol-farmer-detail/:id",
            name: "protocolFarmerDetail",
            component: () =>
              import(
                "../views/esg-platform/progress/farmer/protocolDetail.vue"
              ),
            props: true,
          },
          {
            path: "survey-overview/:id1/:id2",
            name: "surveyOverview",
            component: () =>
              import("../views/esg-platform/survey-builder/surveyOverview.vue"),
            props: true,
          },
          {
            path: "survey-overview-response/:id1/:id2",
            name: "surveyOverviewResponse",
            component: () =>
              import(
                "../views/esg-platform/survey-builder/components/surveyOverviewResponse.vue"
              ),
            props: true,
          },
          {
            path: "assessment-all-responses/:assessmentId/:goalId/:submittedById",
            name: "assessmentAllResponses",
            component: () =>
              import(
                "../views/esg-platform/dashboard/components/protocol/sub-organization/AssessmentFarmerQuestions.vue"
              ),
            props: true,
          },
          {
            path: "assessment-farmer-responses/:assessmentId/:goalId/:submittedById",
            name: "assessmentFarmerResponses",
            component: () =>
              import(
                "../views/esg-platform/dashboard/components/protocol/sub-organization/AssessmentFarmerResponses.vue"
              ),
            props: true,
          },
          {
            path: "assessment-farmer-responses/:assessmentId/:goalId/:submittedById/dimitra-details",
            name: "assessmentFarmerDimitraDetails",
            component: () =>
              import(
                "../views/esg-platform/dashboard/components/protocol/sub-organization/AssessmentFarmerDimitraDetails.vue"
              ),
            props: true,
          },
          {
            path: "assessment-farmer-responses/:assessmentId/:goalId/:submittedById/irrigation-details",
            name: "assessmentFarmerIrrigationDetails",
            component: () =>
              import(
                "../views/esg-platform/dashboard/components/protocol/sub-organization/AssessmentFarmerIrrigationDetails.vue"
              ),
            props: true,
          },
          {
            path: "protocols",
            name: "MyProtocols",
            component: () =>
              import("../views/esg-platform/esg-protocol/Protocols.vue"),
          },
          {
            path: "protocol-details/sub-org/:id/:subOrganizationId?",
            name: "ProtocolDetails",
            component: () =>
              import(
                "../views/esg-platform/dashboard/components/protocol/ProtocolDetails.vue"
              ),
          },
          {
            path: "progress-by-goals/:id",
            name: "ProgressByGoals",
            component: () =>
              import(
                "../views/esg-platform/dashboard/components/protocol/ProgressByGoals.vue"
              ),
          },
          {
            path: "protocol-message/:id?",
            name: "ProtocolMessage",
            component: () =>
              import(
                "../views/esg-platform/dashboard/components/protocol/ProtocolMessage.vue"
              ),
          },
          {
            path: "validation-data/:id/:farmerId?/:subOrganizationId?",
            name: "validationData",
            component: () =>
              import(
                "../views/esg-platform/esg-protocol/components/ValidationData.vue"
              ),
          },
          {
            path: "protocol-details/message/:protocolId/:subOrganizationId?",
            name: "ProtocolMessagesOfSubOrganization",
            component: () =>
              import(
                "../views/esg-platform/dashboard/components/protocol/ProtocolMessage.vue"
              ),
          },
          {
            path: "protocol-details/:id/:subOrganizationId",
            component: () =>
              import(
                "../views/esg-platform/dashboard/components/protocol/sub-organization/ProtocolDetails.vue"
              ),
            children: [
              {
                path: "",
                name: "ProtocolDetailsOfSubOrganization",
                component: () => 
                  import(
                    "../views/esg-platform/dashboard/components/protocol/sub-organization/IssuesAndGoals.vue"
                  ),
              },
              {
                path: "recommendations",
                name: "ProtocolRecommendationsOfSubOrganization",
                component: () =>
                  import(
                    "../views/esg-platform/dashboard/components/protocol/sub-organization/ProtocolRecommendation.vue"
                  ),
              },
            ],
          },
          {
            path: "survey-response/:goalId",
            name: "SurveyResponse",
            component: () => 
              import("../views/esg-platform/survey-builder/SurveyResponse.vue"),
            props: true,
          },
          {
            path: "sdg-goal-icons",
            name: "sgdGoalIcons",
            component: () =>
              import("../views/esg-platform/sdg-goal/index.vue"),
          },
        ],
      },

      {
        path: "manage-trees",
        name: "manageTrees",
        component: () => import("../views/manage-trees/index.vue"),
        redirect: { name: "manageTreesList" },
        meta: { module: "manage-trees", requiresAuth: true },
        children: [
          {
            path: "",
            name: "manageTreesList",
            component: () => import("../views/manage-trees/Lists.vue"),
          },
          {
            path: "view/:id",
            name: "viewTree",
            component: () => import("../views/manage-trees/View.vue"),
          },
          {
            path: "history/:id",
            name: "treeHistory",
            component: () => import("../views/manage-trees/TreeHistory.vue"),
          },
          {
            path: "create",
            name: "createTree",
            component: () => import("../views/manage-trees/Create.vue"),
          },
          {
            path: "edit/:id",
            name: "editTree",
            component: () => import("../views/manage-trees/Edit.vue"),
          },
          {
            path: "bulk-imports",
            name: "bulkImportTrees",
            component: () =>
              import("../views/manage-trees/bulk-imports/BulkImports.vue"),
          },
          {
            path: "bulk-imports/:id",
            name: "bulkImportTreesDetail",
            component: () =>
              import("../views/manage-trees/bulk-imports/BulkImportHistory.vue"),
          },
        ],
      },

      // ========= CARBON-CREDIT ROUTES ===========
      {
        path: "/carbon-credit",
        name: "carbonCredit",
        component: () => import("../views/carbon-credit/index.vue"),
        meta: { module: "carbon-credit", requiresAuth: true },
        children: [
          {
            path: "projects",
            name: "listProjects",
            component: () =>
              import('../views/carbon-credit/projects/List.vue'),
          },
          {
            path: "projects/register/:id?",
            name: "registerProject",
            component: () =>
              import("../views/carbon-credit/projects/Register.vue"),
          },
          {
            path: "projects/edit/:id",
            name: "editProject",
            component: () =>
              import("../views/carbon-credit/projects/Register.vue"),
          },
          {
            path: 'projects/view/:id',
            name: 'viewProject',
            component: () => import('../views/carbon-credit/projects/View.vue')
          },

          {
            path: "plot-tree-mapping",
            name: "plotTreeMapping",
            component: () => import("../views/carbon-credit/plot-tree-mapping/PlotTreeMapping.vue"),
          },

          {
            path: "plot-tree-mapping/:id",
            name: "viewPlotTreeMapping",
            component: () => import("../views/carbon-credit/plot-tree-mapping/PlotTreeMappingView.vue"),
          },

          {
            path: "plot-details/:id",
            name: "plotDetails",
            component: () => import("../views/carbon-credit/plot-tree-mapping/PlotDetails.vue"),
          },
          {
            path: "plot-tree-mapping-assignee/:id",
            name: "plotTreeMappingAssignee",
            component: () => import("../views/carbon-credit/plot-tree-mapping/PlotTreeMappingAssignee.vue"),
          },
          {
            path: 'tree-plot-add/:id?',
            name: 'treePlotAdd',
            component: () => import('../views/carbon-credit/plot-tree-mapping/AddPlotTree.vue')
          },
          {
            path: 'plot-location/:id?',
            name: 'plotLocation',
            component: () => import('../views/carbon-credit/plot-tree-mapping/PlotLocation.vue')
          },
          {
            path: 'farm-location',
            name: 'ChooseFarmLocation',
            component: () => import('../views/carbon-credit/plot-tree-mapping/FarmLocation.vue')
          },
          {
            path: 'projects/preview/:id',
            name: 'projectInfo',
            component: () => import('../views/carbon-credit/projects/ProjectPreview.vue')
          },
          {
            path: 'users',
            name: 'listUsers',
            component: () => import('../views/carbon-credit/users/List.vue')
          },
          {
            path: 'users/view/:id',
            name: 'userDetails',
            component: () => import('../views/carbon-credit/users/UserDetails.vue')
          },
          {
            path: 'users/farm-submission/:farmId',
            name: 'FarmSubmission',
            component: () => import('../views/carbon-credit/users/components/FarmSubmission.vue'),
            props: true
          },
          {
            path: 'activity-logs',
            name: 'carbonCreditActivityLog',
            component: () => import('../views/carbon-credit/activity-logs/List.vue'),
          },
        ]
      },
      {
        path: '/surveys',
        component: () => import('../views/surveys/Index.vue'),
        // No `module` key: access is gated by auth + sidebar (sub-enterprise only)
        // and enforced server-side. A `module` here would trip the permission guard.
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            name: 'surveyList',
            component: () => import('../views/surveys/List.vue'),
          },
          {
            path: ':assessmentId/questions',
            name: 'surveyQuestions',
            component: () => import('../views/surveys/Questions.vue'),
          },
          {
            path: ':assessmentId/answer',
            name: 'surveyAnswer',
            component: () => import('../views/surveys/Answer.vue'),
          },
        ],
      },
      {
        path: '/approval-flow',
        name: 'approvalFlow',
        component: () => import('../views/deforestation/dds/approval-flow/index.vue'),
        meta: { module: 'approval-flow', requiresAuth: true },
        children: [
          {
            path: 'home',
            name: 'dds_root_dashboard',
            component: () => import('../views/deforestation/dds/approval-flow/Dashboard/index.vue'),
          },
          {
            path: 'approval-dashboard',
            name: 'approvalDashboard',
            component: () => import('../views/deforestation/dds/approval-flow/ApprovalDashboard.vue'),
          },
          {
            path: 'eudr-due-diligence-reports',
            name: 'dds_root_due_diligence_report',
            component: () => import('../views/deforestation/dds/approval-flow/AdminDueDiligenceReport.vue'),
          },
          {
            path: 'view-summary-report/:id',
            name: 'viewSummaryReport',
            component: () => import('../views/deforestation/dds/approval-flow/ViewSummaryReport.vue'),
          },
          {
            path: 'settings',
            name: 'root_settings',
            component: () => import('../views/deforestation/dds/approval-flow/settings.vue'),
          },
          {
            path: 'shipment-details/:id',
            name: 'approvalShipmentDetails',
            component: () => import('../views/deforestation/dds/approval-flow/shipment/ViewShipmentDetails.vue'),
          },
          {
            path: 'cooperatives',
            name: 'root_cooperatives',
            component: () => import('../views/deforestation/dds/approval-flow/cooperatives/CorporativeList.vue'),
          },
          {
            path: 'cooperatives/view/:id',
            name: 'viewCooperative',
            component: () => import('../views/deforestation/dds/approval-flow/cooperatives/components/CorporativeDetails.vue'),
          },
          // ========= EXCHANGE ROUTES ===========
          {
            path: 'dds-report-exchange',
            name: 'dds_root_exchange',
            component: () => import('../views/deforestation/dds/approval-flow/exchange/index.vue'),
          },
        ]
      },
      {
        path: '/finance-management',
        name: 'financeManagement',
        component: () => import('../views/finance-management/index.vue'),
        meta: { module: 'finance-management', requiresAuth: true },
        children: [
          {
            path: 'dashboard',
            name: 'financeDashboard',
            component: () => import('../views/finance-management/dashboard/Dashboard.vue'),
          },
          {
            path: 'loan-programs',
            name: 'LoanProgram',
            component: () => import('../views/finance-management/loan-programs/List.vue'),
          },
          {
            path: 'loan-programs/view/:id',
            name: 'loanProgramDetails',
            component: () => import('../views/finance-management/loan-programs/ProgramDetails.vue'),
          },
          {
            path: 'loan-programs/create',
            name: 'createLoanProgram',
            component: () => import('../views/finance-management/loan-programs/CreateProgram.vue'),
          },
          {
            path: 'loan-applications',
            name: 'LoanApplication',
            component: () => import('../views/finance-management/loan-applications/List.vue'),
          },
          {
            path: 'loan-applications/:id',
            name: 'loanApplicationDetails',
            component: () => import('../views/finance-management/loan-applications/Details.vue'),
          },
          {
            path: 'loan-applications/:id/approval',
            name: 'loanApplicationApproval',
            component: () => import('../views/finance-management/loan-applications/Details.vue'),
          },
          {
            path: 'loan-applications/:id/farm-reports',
            name: 'loanApplicationFarmReports',
            component: () =>
              import('../views/finance-management/loan-applications/FarmReports.vue'),
          },
          {
            path: 'loan-programs/edit/:id',
            name: 'editLoanProgram',
            component: () => import('../views/finance-management/loan-programs/CreateProgram.vue'),
          },
          {
            path: 'banks',
            name: 'Bank',
            component: () => import('../views/finance-management/banks/List.vue'),
          },
          {
            path: 'banks/create',
            name: 'createBank',
            component: () => import('../views/finance-management/banks/AddNewBank.vue'),
          },
          {
            path: 'banks/view/:id',
            name: 'bankDetails',
            component: () => import('../views/finance-management/banks/BankDetails.vue'),
          },
          {
            path: 'loan-programs/application-form-view/:id',
            name: 'applicationFormView',
            component: () => import('../views/finance-management/loan-programs/ApplicationFormView.vue'),
          },
        ]
      },

      // Enterprise Settings Routes
      {
        path: '/enterprise',
        name: 'enterprise',
        component: () => import('../views/enterprise-settings/Index.vue'),
        meta: { module: 'enterprise-settings', requiresAuth: true },
        redirect: { name: 'enterpriseProfileSettings' },
        children: [ 
          {
            path: 'general-settings',
            name: 'enterpriseGeneralSettings',
            component: () => import('../views/enterprise-settings/GeneralSettings.vue'),
          },
          {
            path: 'farm-settings',
            name: 'enterpriseFarmSettings',
            component: () => import('../views/enterprise-settings/FarmSettings.vue'),
          },
          {
            path: 'uom-settings',
            name: 'enterpriseUOMSettings',
            component: () => import('../views/enterprise-settings/UnitSettings.vue'),
          },
          {
            path: 'crop-variety-settings',
            name: 'enterpriseCropVarietySettings',
            component: () => import('../views/enterprise-settings/CropTypeAndVarietySetting.vue'),
          },
          {
            path: 'profile-settings',
            name: 'enterpriseProfileSettings',
            component: () => import('../views/profile-auth/Settings.vue'),
            meta: { module: 'profile_authentication' },
          },
        ]
      },
      // ========= REPORTS ROUTES ===========
      {
        path: '/yield-prediction',
        name: 'yieldPrediction',
        component: () => import('../views/reports/yield-prediction/Index.vue'),
        meta: { module: 'yield_prediction', requiresAuth: true },
        children: [
          {
            path: '/',
            name: 'yieldPredictionList',
            component: () => import('../views/reports/yield-prediction/Lists.vue'),
          },
          {
            path: 'create',
            name: 'yieldPredictionCreate',
            component: () => import('../views/reports/yield-prediction/Create.vue'),
          },
          {
            path: 'view/:id',
            name: 'yieldPredictionView',
            component: () => import('../views/reports/yield-prediction/View.vue'),
          }
        ]
      },
      {
        path: "/land-suitability",
        name: "landSuitabilityDesign",
        component: () =>
          import("../views/reports/land-suitability/Index.vue"),
        meta: { module: "land_suitability", requiresAuth: true },
        children: [
          {
            path: "",
            name: "landSuitabilityDesignList",
            component: () =>
              import("../views/reports/land-suitability/Lists.vue"),
          },
          {
            path: "create",
            name: "landSuitabilityDesignCreate",
            component: () =>
              import("../views/reports/land-suitability/Create.vue"),
          },
          {
            path: "view/:id",
            name: "landSuitabilityDesignView",
            component: () =>
              import("../views/reports/land-suitability/View.vue"),
          },
        ]
      },

      // ========= CROP PROGRESSION (VEGETATION VIGOR) ROUTES ===========
      {
        path: '/vegetation-vigor',
        component: () => import('../views/reports/crop-progression/Index.vue'),
        meta: { module: 'reports', requiresAuth: true },
        children: [
          {
            path: '',
            name: 'cropProgressionList',
            component: () => import('../views/reports/crop-progression/Lists.vue'),
          },
          {
            path: 'create',
            name: 'cropProgressionCreate',
            component: () => import('../views/reports/crop-progression/Create.vue'),
          },
          {
            path: 'view/:reportUid',
            name: 'cropProgressionView',
            component: () => import('../views/reports/crop-progression/View.vue'),
          },
          {
            path: 'compare/:reportUid',
            name: 'cropProgressionCompare',
            component: () => import('../views/reports/crop-progression/Comparison.vue'),
          },
        ],
      },

      // ========= FARM PRODUCTIVITY (PRODUCTIVITY ZONES) ROUTES ===========
      {
        path: '/farm-productivity',
        component: () => import('../views/reports/farm-productivity/Index.vue'),
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            name: 'farmProductivityList',
            component: () => import('../views/reports/farm-productivity/Lists.vue'),
          },
          {
            path: 'create',
            name: 'farmProductivityCreate',
            component: () => import('../views/reports/farm-productivity/Create.vue'),
          },
          {
            path: 'view/:reportUid',
            name: 'farmProductivityView',
            component: () => import('../views/reports/farm-productivity/View.vue'),
          },
        ],
      },
      {
        path: "/land-suitability",
        name: "landSuitabilityDesign",
        component: () =>
          import("../views/reports/land-suitability/Index.vue"),
        meta: { module: "land-suitability", requiresAuth: true },
        children: [
          {
            path: "",
            name: "landSuitabilityDesignList",
            component: () =>
              import("../views/reports/land-suitability/Lists.vue"),
          },
          {
            path: "create",
            name: "landSuitabilityDesignCreate",
            component: () =>
              import("../views/reports/land-suitability/Create.vue"),
          },
          {
            path: "view/:id",
            name: "landSuitabilityDesignView",
            component: () =>
              import("../views/reports/land-suitability/View.vue"),
          },
        ],
      },

      // ========= ANOMALY DETECTION ROUTES ===========
      {
        path: '/anomaly-detection',
        component: () => import('../views/reports/anomaly-detection/Index.vue'),
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            name: 'anomalyDetectionList',
            component: () => import('../views/reports/anomaly-detection/Lists.vue'),
          },
          {
            path: 'create',
            name: 'anomalyDetectionCreate',
            component: () => import('../views/reports/anomaly-detection/Create.vue'),
          },
          {
            path: 'view/:reportUid',
            name: 'anomalyDetectionView',
            component: () => import('../views/reports/anomaly-detection/View.vue'),
          },
          {
            path: 'compare/:reportUid',
            name: 'anomalyDetectionCompare',
            component: () => import('../views/reports/anomaly-detection/Comparison.vue'),
          },
        ],
      },

      // ========= AI REPORTS DASHBOARD (CLIENT ADMIN) ===========
      {
        path: '/ai-reports',
        name: 'aiReportsDashboard',
        component: () => import('../views/reports/ai-reports/Dashboard.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: '/ai-reports/manage',
        name: 'aiReportsManage',
        // Parent cooperative admin only; sub-org admins are redirected to the dashboard.
        component: () => import('../views/reports/ai-reports/Manage.vue'),
        meta: { requiresAuth: true, clientAdminOnly: true },
      },
      {
        path: '/ai-reports/usage-log',
        name: 'aiReportsUsageLog',
        component: () => import('../views/reports/ai-reports/UsageLog.vue'),
        meta: { requiresAuth: true },
      },
    ],
  },
];
